import './styles.scss'

import React, { useEffect, useState } from 'react'
import { I18n } from 'react-redux-i18n'
import { signup as signupApi } from 'api'
import { bindActionCreators } from 'redux'
import operatorActions from 'redux/actions/user'
import { nxAuthTokenAct } from 'redux_new/actions'
import { connect } from 'react-redux'
import SignupLoadInit from '../SignupLoadInit'
import SignupErrorInvalidToken from '../TokenInvalid'

const SignupVerify = (props) => {
  const {
    match: {
      params: { token },
    },
  } = props

  const operatorActs = bindActionCreators(operatorActions, props.dispatch)
  const onNxAuthToken = bindActionCreators(nxAuthTokenAct, props.dispatch)

  const [loading, setLoading] = useState(true)

  useEffect(() => {
    signupApi.signupVerify({ token }).then(({ data }) => {
      onNxAuthToken.add(data.token)
      return data.token
    }).then((authToken) => {
      operatorActs.getOperator(authToken, true)
    }).catch(({ response = {} }) => {
      setLoading(false)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token])

  if (loading) {
    return <SignupLoadInit></SignupLoadInit>
  } else {
    return  <SignupErrorInvalidToken title={I18n.t('signup_step_verify_token_error')} description={I18n.t('signup_generic_error')}></SignupErrorInvalidToken>
  }
}

export default connect()(SignupVerify)